<template>
  <div>
    <div v-if="loading" class="teasers">
      <LazyLcSkeleton v-for="index of skeletons" :key="index" height="18rem" radius="medium" />
    </div>

    <slot v-if="noResults && !loading" name="no-results">
      <LazyNoResults :headline="$t('teasers.noresults.headline')" />
    </slot>

    <div v-else class="teasers">
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
type TeaserWrapperProps = {
  loading?: boolean
  noResults?: boolean
  skeletons?: number
}

const { skeletons = 1 } = defineProps<TeaserWrapperProps>()
</script>

<style lang="scss" scoped>
.teasers {
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: minmax(0, 1fr);
  gap: token('size/space/gap/100');
  padding-bottom: token('size/space/gap/300');

  @include media-desktop {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: token('size/space/gap/200');
  }
}
</style>
